import { render, staticRenderFns } from "./StartView.vue?vue&type=template&id=4af918b9"
import script from "./StartView.vue?vue&type=script&lang=js"
export * from "./StartView.vue?vue&type=script&lang=js"
import style0 from "./StartView.vue?vue&type=style&index=0&id=4af918b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports